import { nriWhatsappUrl, nriBookingUrl } from "../../data/nriTaxData";
import { ArrowRight, Calendar } from "lucide-react";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 flex-shrink-0">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const steps = [
  {
    n: "1",
    parts: [
      { text: "Send WhatsApp:", muted: true },
      { text: " AUDIT", accent: true },
    ],
  },
  {
    n: "2",
    parts: [
      { text: "I reply within ", muted: true },
      { text: "2 hours", accent: true },
      { text: " — 2 qualifying questions", muted: true },
    ],
  },
  {
    n: "3",
    parts: [
      { text: "30-minute call", accent: true },
      { text: " — residency history, income, filing situation", muted: true },
    ],
  },
  {
    n: "4",
    parts: [
      { text: "Written ", muted: true },
      { text: "NRI Tax Position summary", accent: true },
      { text: " delivered in ", muted: true },
      { text: "48 hours", accent: true },
      { text: " — residency, DTAA, Schedule FA, refund identified in ₹", muted: true },
    ],
  },
  {
    n: "5",
    parts: [
      { text: "Engage if you want.", muted: true },
      { text: " No charge if you don't.", accent: true },
      { text: " No pressure.", muted: true },
    ],
  },
];

export const NriFinalCtaSection = () => (
  <section id="nri-cta" className="relative py-28" style={{ background: "#1a1c1b" }}>
    <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
    <div className="max-w-[87.5rem] mx-auto px-10">
      <div className="max-w-4xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <p
            className="font-semibold uppercase mb-1"
            style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(0.85rem, 0.7rem + 0.6vw, 1rem)", letterSpacing: "-0.01em" }}
          >
            <span className="text-[#dfddd6]/60">Find out exactly</span>
            <span className="text-[#888680]/40"> where you stand</span>
          </p>
          <h2
            className="font-black uppercase leading-tight"
            style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(2rem, 1.6rem + 2.5vw, 4rem)", letterSpacing: "-0.03em" }}
          >
            <span className="text-[#d9fb06]">In 48 Hours.</span>
          </h2>
          <p className="text-[#888680]/60 text-sm mt-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            Here's exactly what happens:
          </p>
        </div>

        {/* Steps */}
        <div className="flex flex-col gap-2 mb-14">
          {steps.map((item) => (
            <div key={item.n} className="flex items-center gap-4 bg-[#302f2c]/30 border border-[#3f4816]/10 rounded-sm px-6 py-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center">
                <span className="text-[#d9fb06] font-black text-sm" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{item.n}</span>
              </div>
              <p className="text-sm leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {item.parts.map((part, i) =>
                  part.accent ? (
                    <span key={i} className="text-[#d9fb06] font-bold">{part.text}</span>
                  ) : (
                    <span key={i} className="text-[#888680]">{part.text}</span>
                  )
                )}
              </p>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col items-center gap-4">
          <a
            href={nriWhatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nri-final-whatsapp-cta"
            className="group w-full max-w-lg inline-flex items-center justify-center gap-3 bg-[#25D366] text-white font-bold text-sm px-8 py-5 rounded-full transition-all duration-300 hover:scale-[1.02] hover:brightness-110 active:scale-[0.98] shadow-lg shadow-[#25D366]/20"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            <WaIcon />
            <span>
              WhatsApp <span className="opacity-70">"</span>AUDIT<span className="opacity-70">"</span>
              <span className="opacity-70"> — Get My Tax Report + Filing</span>
            </span>
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 flex-shrink-0" />
          </a>

          <div className="flex items-center gap-4 w-full max-w-lg">
            <div className="flex-1 h-px bg-[#3f4816]/30" />
            <span className="text-[#888680]/40 text-xs" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>— or —</span>
            <div className="flex-1 h-px bg-[#3f4816]/30" />
          </div>

          <a
            href={nriBookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nri-final-calendly-cta"
            className="group w-full max-w-lg inline-flex items-center justify-center gap-2 border border-[#d9fb06]/30 text-[#d9fb06] font-bold text-sm px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.02] hover:bg-[#d9fb06]/10 active:scale-[0.98] uppercase tracking-tight"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            <Calendar size={15} />
            Book a 30-Minute Strategy Call
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 flex-shrink-0" />
          </a>

          <p className="text-[#888680]/25 text-xs text-center" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            wa.me/919289791199?text=AUDIT
          </p>
        </div>
      </div>
    </div>
  </section>
);
